// 렌더링 단계에서 사용할 폰트 정보를 공유하기 위한 컨텍스트
import { createContext } from 'react';
import { LocalFontInfo } from './load-font-from-text-item';

export type FontInfosContextType = Record<string, LocalFontInfo>;

// 렌더 트리 전반에서 동일한 로컬 폰트 메타 데이터를 공유
export const FontInfoContext = createContext<Record<string, LocalFontInfo>>({});
